import React from 'react';
import { Location } from '@reach/router';

const LocationWrapper = (WrappedComponent) => (props) =>
  <Location>{(location) => <WrappedComponent {...props} location={location.location} />}</Location>;

export default LocationWrapper;
